import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export type AuthErrorType = 'oauth_error' | 'session_error' | 'unknown';

export interface AuthError {
  type: AuthErrorType;
  message: string;
}

export interface AuthState {
  user: User | null;
  session: Session | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: AuthError | null;
  signInWithGoogle: () => Promise<void>;
  signInWithMicrosoft: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);
